module.exports = __webpack_public_path__ + "img/markerOrigin.837e0e3d.svg";